module.exports = __webpack_public_path__ + "img/event-balboa-day.1c164da.jpg";